import { APICallV4Post } from 'reactApp/api/APICall';
import type { ProductsListApiResponse, ProductsListArgs } from 'reactApp/api/billing/products/ProductsAPICall.types';

export class ProductsAPICall extends APICallV4Post<ProductsListApiResponse, ProductsListArgs> {
    _method = 'billing/products';
}
